import { createStore, applyMiddleware } from 'redux'
function set_background(state = "", action) {
  switch (action.type) {
    case 'root':
      return 'root';
    case 'newrequest':
      return 'newrequest';
    case 'increquest':
      return 'increquest';
    case 'pishfactors':
      return 'pishfactors';
    case 'confirmfactors':
      return 'confirmfactors';
    case 'reports':
      return 'reports';
    case 'reportkala':
      return 'reportkala';
    case 'useraccess':
      return 'useraccess';
    case 'kala':
      return 'kala';
    case 'backup':
      return 'backup';
    default:
      return ""
  }
}
let store = createStore(set_background);
//store.dispatch(() => console.log(store.getState()));
export default store;



// WEBPACK FOOTER //
// ./src/store.js